export const environment = {
	production: false,
	backend: 'https://microsites-fs1.appspot.com/api/v1/',
};
